<div class="spinner-container" *ngIf="loading">
    <mat-spinner class="content-box"></mat-spinner>
</div>

<mat-card appearance="outlined" *ngIf="!loading" class="personal">
    <mat-card-header class="text-uppercase tal">
        <mat-card-title>{{'detailsTexts.userDetails' | translate}}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="row">
            <div class="col-3 tal key">
                <strong>{{'businessTexts.user' | translate}}: </strong>
            </div>
            <div class="col text-left">
                {{getCurrentUserName()}}
            </div>
        </div>
        <div class="row">
            <div class="col-3 tal key">
                <strong>{{'businessTexts.role' | translate}}: </strong>
            </div>
            <div class="col text-left">
                {{getCurrentUserRole()}}
            </div>
        </div>

    </mat-card-content>
    <mat-card-footer></mat-card-footer>
</mat-card>

<mat-card appearance="outlined" *ngIf="!loading">
    <mat-card-header class="text-uppercase tal">
        <mat-card-title>            
            <img class="business-logo" src={{businessLogo}} alt="Business Logo" />
            <div class="label-header">
                {{'detailsTexts.companyDetails' | translate}}
            </div>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="row">
            <div class="col-3 tal key">
                <strong>{{'businessTexts.nameLabel' | translate}}:</strong>
            </div>
            <div class="col text-left">
                {{getCompanyName()}}
            </div>
        </div>
        <div class="row">
            <div class="col-3 tal key">
                <strong> {{'businessTexts.identifier' | translate}}:</strong>
            </div>
            <div class="col text-left">
                {{companyData.eik}}
            </div>
        </div>
        <div class="row">
            <div class="col-3 tal key">
                <strong> {{'businessTexts.address' | translate}}:</strong>
            </div>
            <div class="col text-left">
                {{companyData.address}}
            </div>
        </div>
        <div class="row">
            <div class="col-3 tal key services">
                <strong> {{'businessTexts.accessToServices' | translate}}:</strong>
            </div>
            <div class="col text-left">
                <!-- TO DO: Decide table or list -->

                <!-- <table mat-table [dataSource]="servicesDataSource" class="mat-elevation-z8 services">
                    <ng-container matColumnDef="icon">
                        <td mat-cell *matCellDef="let element"> <cqes-icon
                                icon="{{getIcon(element.serviceType)}}"></cqes-icon> </td>
                    </ng-container>
                    <ng-container matColumnDef="name">
                        <td mat-cell *matCellDef="let element"> {{getServiceName(element)}}</td>
                    </ng-container>
                    <tr mat-row *matRowDef="let row; columns: servicesColumns;"
                        [ngClass]="{'disabled': !isActive(row), 'active': isActive(row) }"></tr>
                </table> -->

                <div class="services services-list">
                    <div [ngClass]="{'disabled': !isActive(element), 'active': isActive(element) }"
                        *ngFor="let element of servicesDataSource">
                        <cqes-icon icon="{{getIcon(element.serviceType)}}" class="service-icon"></cqes-icon>
                        {{getServiceName(element)}}
                    </div>
                </div>
            </div>
        </div>
        

        <div class="management" *ngIf="isAdmin">
          <cloud-business-users-table [tableName]="'main'" [inputValue]="asyncInputValue"></cloud-business-users-table>
             <!-- User Groups Tsble -->
          <div class="mat-elevation-z8 groups">
            <table mat-table [dataSource]="dataSource" multiTemplateDataRows>

                <!-- Name Column -->
                <ng-container matColumnDef="groupName">
                    <th mat-header-cell *matHeaderCellDef> {{'businessTexts.group' | translate}} </th>
                    <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                </ng-container>

                <!-- Expandable Content-->
                <ng-container matColumnDef="expand">
                    <th mat-header-cell *matHeaderCellDef [attr.aria-label]="'common.actions' | translate">&nbsp;</th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-icon-button [attr.aria-label]="'common.expandRow' | translate"
                            (click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation()">
                            <mat-icon *ngIf="expandedElement !== element">keyboard_arrow_down</mat-icon>
                            <mat-icon *ngIf="expandedElement === element">keyboard_arrow_up</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <!-- Actions Column -->
                <ng-container matColumnDef="groupActions">
                    <th mat-header-cell *matHeaderCellDef> {{'businessTexts.actions' | translate}} </th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-icon-button matTooltip="{{'businessTexts.edit' | translate}}"
                            (click)="$event.stopPropagation();onEditGroup(element)">
                            <cqes-icon icon="edit"></cqes-icon>
                        </button>
                        <button mat-icon-button matTooltip="{{'businessTexts.delete' | translate}}"
                            (click)="$event.stopPropagation();onDeleteGroup(element)">
                            <cqes-icon icon="delete"></cqes-icon>
                        </button>
                    </td>
                </ng-container>

                <!-- Header top -->
                <ng-container matColumnDef="header-top">
                    <th mat-header-cell *matHeaderCellDef class="header" [style.text-align]="center" [attr.colspan]="3">
                        <div class="wrap">
                            <div class="label">
                                {{'businessTexts.userGroups' | translate}}
                            </div>
                            <div class="add-icon">
                                <button mat-icon-button matTooltip="{{'businessTexts.add' | translate}}"
                                    (click)="addGroup()">
                                    <div class="vertical-align">
                                        <div class="plus">
                                            +
                                        </div>
                                        <cqes-icon icon="group" class="add"></cqes-icon>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </th>
                </ng-container>

                <!-- ExpandableColumn  -->
                <ng-container matColumnDef="expandedDetail">
                    <td mat-cell *matCellDef="let element" [attr.colspan]="3">
                        <div class="element-detail"
                            [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                            <div class="element-position">
                                <cloud-business-users-table [inputValue]="asyncInputValue" [tableName]="'groups'" [group]="element"></cloud-business-users-table>
                            </div>
                        </div>
                    </td>
                </ng-container>
                <tr mat-row *matRowDef="let element; columns: groupsColumns;" class="element-row"
                    [class.expanded-row]="expandedElement === element"
                    (click)="expandedElement = expandedElement === element ? null : element">
                </tr>
                <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
                <tr mat-header-row *matHeaderRowDef="['header-top']" class="main-header"></tr>
            </table>

            <mat-paginator #paginator [pageSize]="tableHelper.pageSize" [pageSizeOptions]="tableHelper.pageSizeOptions">
            </mat-paginator>
          </div>
        </div>
    </mat-card-content>
    <mat-card-footer></mat-card-footer>
</mat-card>